import {
  PageTypeEnum,
  WebsiteUtilityPageType,
  websiteUtilityPages,
} from 'common/enums/PageTypeEnum'
import { WebsitePageSet } from 'src/shared/types/website-page-interface'

export const isWebsiteUtilityPageType = (
  pageType: PageTypeEnum,
): pageType is WebsiteUtilityPageType => {
  return websiteUtilityPages.includes(pageType as WebsiteUtilityPageType)
}

export const splitWebsitePageSets = (pageSets: WebsitePageSet[]) => {
  return pageSets.reduce(
    (acc, pageSet) => {
      if (isWebsiteUtilityPageType(pageSet.pageType)) {
        acc.utilityPageSets.push(pageSet)
      } else {
        acc.regularPageSets.push(pageSet)
      }

      return acc
    },
    {
      regularPageSets: [] as WebsitePageSet[],
      utilityPageSets: [] as WebsitePageSet[],
    },
  )
}
